/**
 * External Dependencies
 */
import 'jquery';
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";

$('body').on('click', function (e) {
  const isBasketModalClose = $(e.target).parents('.basket-popup-wrap').length;
  const isCloseBtnClick = $(e.target).parent().hasClass('popup-basket__close');
  if (!isBasketModalClose || isCloseBtnClick) {
    $('.popup-basket').removeClass('open');
  }

  const isContactUsBtn = e.target.classList.contains('open-contact-us-modal') || $(e.target).parents('.open-contact-us-modal').length;
  if (isContactUsBtn) {
    const instancesWrapper = $('#instances-wrapper');

    if (instancesWrapper.length) {
      const enquiryUrl = instancesWrapper.data('enquiry_url');
      if ('' !== enquiryUrl) {
        e.preventDefault();
        Fancybox.show([{ src: enquiryUrl, type: "iframe" }]);
      }
    }
  }
})

$('.instance-enquiry').on('click', function(e) {
  const href = $(this).attr('href');

  if ('' !== href && '#' !== href) {
    e.preventDefault()
    Fancybox.show([{ src: href, type: "iframe" }]);
  }
});

const jsBasket = $('.js-basket');
if (jsBasket.length) {
  $('.js-basket').each(function () {
    const $btn = $(this);
    const popup = $btn.next('.popup-basket');
    $btn.on('click', function () {
      $('.popup-basket').each(function () {
        $(this).removeClass('open');
      })
      popup.toggleClass('open');
    })
    popup.find('.popup-basket__close').on('click', function (e) {
      popup.removeClass('open');
    })
  })
}